import React from "react";
import styled from "styled-components";
import { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0.1rem;
  cursor: pointer;
  animation: ${fadeIn} 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  flex: 0 0 auto;
  min-width: 0;
  position: relative;

  &:hover {
    transform: translateY(-1px);
  }
`;

const SvgContainer = styled.div`
  position: relative;
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.15rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "";
    position: absolute;
    left: -10%;
    right: -10%;
    top: 50%;
    height: 1px;
    background-color: rgb(115, 115, 115);
    transform: rotate(-45deg);
    opacity: var(--strike-through-opacity, 0);
    transform-origin: center;
    pointer-events: none;
  }

  @media (max-width: 1200px) {
    width: 0.7rem;
    height: 0.7rem;
    margin-right: 0.1rem;
  }

  @media (max-width: 1000px) {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0;
  }

  @media (max-width: 600px) {
    width: 0.8rem;
    height: 0.8rem;
  }
`;

const StyledSvg = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
`;

const Rectangle = styled.rect`
  fill: var(--fill);
  stroke: var(--stroke);
  stroke-width: 1;
  transition: all 350ms ease-in-out;
`;

const Label = styled.span`
  font-size: clamp(0.8rem, calc(0.4rem + 0.4vw), 0.7rem);
  color: var(--text-color);
  text-transform: uppercase;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 1 auto;
  max-width: clamp(4rem, calc(2rem + 1.5vw), 4rem);
  line-height: 1;
  padding-top: 0.1rem;

  @media (min-width: 1600px) {
    font-size: clamp(0.7rem, calc(0.5rem + 0.5vw), 0.9rem);
    max-width: clamp(7rem, calc(2.5rem + 2vw), 10rem);
  }

  @media (max-width: 1300px) {
    font-size: clamp(0.4rem, calc(0.6rem + 0.5vw), 0.6rem);
    max-width: clamp(2rem, calc(1.5rem + 1vw), 5rem);
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;

interface Props {
  color: string;
  isEnabled: boolean;
  isSelected: boolean;
  label: string;
}

export default ({ color, isEnabled, isSelected, label }: Props) => {
  const style = {
    "--fill": isEnabled ? (isSelected ? color : "white") : "#ccc",
    "--stroke": color,
    "--text-color": isEnabled ? (isSelected ? color : "#666") : "#999",
    "--strike-through-opacity": isEnabled ? 0 : 1,
  };

  return (
    <Container>
      <SvgContainer style={style}>
        <StyledSvg viewBox="0 0 16 16">
          <Rectangle x="2" y="2" width="12" height="12" />
        </StyledSvg>
      </SvgContainer>
      <Label title={label}>{label}</Label>
    </Container>
  );
};
